import { Card, CardHeader, CardTitle, CardContent } from '@repo/ui';

export default function Defi() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">DeFi</h1>
        <p className="text-gray-600 dark:text-gray-400">Total Value Locked and protocol analytics</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Coming Soon</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <div className="text-6xl mb-4">🚧</div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
              DeFi Analytics
            </h3>
            <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto">
              Phase 3 will include TVL tracking, protocol rankings, and DefiLlama integration.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
